module.exports = __webpack_public_path__ + "static/media/slogn-technology.9a334d4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/slogn-technology.svg
// module id = 199
// module chunks = 6